const TokenKey = 'yingFeng-Token'
const UserKey = 'yingFeng-User'
/**
 * 获取token
 * @returns
 */
export function getToken() {
    return sessionStorage.getItem(TokenKey)
}
/**
 * 设置token
 * @param {String} token
 * @returns
 */
export function setToken(token) {
    return sessionStorage.setItem(TokenKey, token)
}
/**
 * 删除token
 * @returns
 */
export function removeToken() {
    return sessionStorage.removeItem(TokenKey)
}
/**
 * 获取user
 * @returns
 */
export function getUser() {
    const user = sessionStorage.getItem(UserKey)
    if (user) return JSON.parse(user)
    else return null
}
/**
 * 设置user
 * @param {*} user
 * @returns
 */
export function setUser(user) {
    return sessionStorage.setItem(UserKey, JSON.stringify(user))
}

/**
 * 删除user
 * @returns
 */
export function removeUser() {
    return sessionStorage.removeItem(UserKey)
}

export function setTVue(token) {
    return sessionStorage.setItem('Vue', token)
}

export function getVue() {
    return sessionStorage.getItem('Vue')
}
